/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx, css } from "@emotion/react";
import { useState } from "react";
import { CONFIG } from "../../config";
import { defaultOutfitDimensionGrid } from "../../contexts/Outfits/AddOutfit/AddOutfitReducer";
import { scaledLeftRight } from "../../helpers/cssHelper";
import { PieceSpacer } from "../general/misc/PieceSpacer";

const boxClass = `flex pointer-events-none cursor-pointer select-none rounded-md`;

const PieceSpacerWrapper = ({
	children,
	outfit_piece = null,
	type = "",
	noPosition = false,
	noSpacing = false,
	contentHidden = false,
	contentClassname = "",
}) => {
	return (
		<PieceSpacer
			type={type}
			width_scale={outfit_piece.width_scale}
			height_scale={outfit_piece.height_scale}
			top_scale={noPosition ? 0 : outfit_piece.top_scale}
			left_scale={noPosition ? 0 : outfit_piece.left_scale}
			z_index={outfit_piece.z_index}
			spacing_scale={noSpacing ? 0 : outfit_piece.spacing_scale}
			empty={!outfit_piece.piece_id}
			key={outfit_piece.position}
			className={`${boxClass}`}
		>
			{outfit_piece.piece_image_name && (
				<img
					className={`${contentClassname} opacity-0 ${
						!contentHidden ? "opacity-100" : "opacity-0"
					} transition-opacity duration-300 object-contain pointer-events-none rounded-md w-full h-full`}
					src={`${CONFIG.IMAGE_URL}${outfit_piece.piece_image_name}`}
				/>
			)}
			{children}
		</PieceSpacer>
	);
};

export const OutfitPiece = ({
	outfit_piece = null,
	type = "",
	position = 1,
}) => {
	return outfit_piece ? (
		<PieceSpacerWrapper
			key={position}
			outfit_piece={outfit_piece}
			type={type}
			contentHidden={outfit_piece.split_scale > 0}
		>
			{outfit_piece.split_scale > 0 && (
				<div>
					<div
						css={scaledLeftRight(
							type,
							-outfit_piece.split_scale,
							true
						)}
						className="absolute top-0 w-1/2 h-full overflow-hidden"
					>
						<PieceSpacerWrapper
							type={type}
							outfit_piece={outfit_piece}
							noPosition={true}
							noSpacing={true}
						/>
					</div>
					<div
						css={scaledLeftRight(
							type,
							-outfit_piece.split_scale,
							false
						)}
						className="absolute top-0 w-1/2 h-full overflow-hidden"
					>
						<PieceSpacerWrapper
							type={type}
							outfit_piece={outfit_piece}
							noPosition={true}
							noSpacing={true}
							contentClassname={"relative top-0 -left-1/2"}
						/>
					</div>
				</div>
			)}
		</PieceSpacerWrapper>
	) : (
		<PieceSpacer
			type={type}
			width_scale={defaultOutfitDimensionGrid[position].width_scale}
		/>
	);
};
